var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBots = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 14,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 0c.904 0 1.636.723 1.636 1.615 0 .72-.476 1.33-1.135 1.539L6.5 4.307H10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8.681v1.155a.5.5 0 0 1-.991.09l-.008-.09-.001-1.155H4V13.5a.5.5 0 0 1-.992.09L3 13.5v-1.193H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3.5V3.154a1.618 1.618 0 0 1-1.136-1.539C4.364.723 5.096 0 6 0Zm2.5 6.5h-5l-.117.007a1 1 0 0 0 0 1.986L3.5 8.5h5l.117-.007A1 1 0 0 0 8.5 6.5Z"
})));
export default SvgBots;